import { render, staticRenderFns } from "./SlugInput.vue?vue&type=template&id=55875662&scoped=true"
import script from "./SlugInput.vue?vue&type=script&lang=js"
export * from "./SlugInput.vue?vue&type=script&lang=js"
import style0 from "./SlugInput.vue?vue&type=style&index=0&id=55875662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55875662",
  null
  
)

export default component.exports